import {IWorkspaceState} from '../../../../app/@reducer/WorkspaceRedux'
import {useNotifications, useProducts} from '../../../../app/@contexts'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import React, {FC, useCallback, useMemo, useRef} from 'react'
import SavTabPane from './SavTabPane'
import NotificationTabPane from './NotificationTabPane'
import {useScrollHandler} from '../../../../app/features'

const HeaderNotificationsMenu: FC = () => {

  const {
    refetch,
    loading,
    setLoading,
    userNotifications: {ticket_message, notifications, count},
  } = useNotifications()
  const {products: {sav}} = useProducts()
  const isAuthorizedSAV = !!sav.activated_at
  const scrollRef = useRef<HTMLDivElement>(null)
  const savScrollRef = useRef<HTMLDivElement>(null) // Référence pour SavTabPane

  const {
    colors: {
      primary,
      secondary,
    },
  } = useSelector<RootState>(({workspace}) => workspace, shallowEqual) as IWorkspaceState

  const navLineTabs = [
    {title: 'sav', isAuth: isAuthorizedSAV, count: ticket_message?.count},
    {title: 'autres', isAuth: true, count: notifications?.count},
  ]

  const NavTabs = useMemo(() => {
    return (
      <ul className="nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9">
        {navLineTabs.map((tab, index) => (
          tab.isAuth && (
            <li className="nav-item" key={index}>
              <a
                className={`nav-link text-white opacity-75 opacity-state-100 pb-4 text-capitalize position-relative ${index === 0 ? 'active' : ''}`}
                data-bs-toggle="tab"
                href={`#kt_top_bar_notifications_${index + 1}`}
              >
                {tab.title}

                <span
                  className="badge badge-circle fs-8 p-0 text-success position-absolute translate-middle top-0 start-100">{tab.count && tab.count > 0 ? tab.count : ''}</span>
              </a>
            </li>
          )
        ))}
      </ul>
    )
  }, [navLineTabs])

  const handleScrollEnd = useCallback(() => {
    refetch()
  }, [refetch])

  useScrollHandler({ref: scrollRef, onScrollEnd: handleScrollEnd, setLoading})
  useScrollHandler({ref: savScrollRef, onScrollEnd: handleScrollEnd, setLoading})

  return (
    (
      <div
        className="menu menu-sub menu-sub-dropdown menu-column w-375px w-lg-450px"
        data-kt-menu="true"
      >
        <div
          className="d-flex flex-column bgi-no-repeat rounded-top"
          style={{background: `linear-gradient(55deg, ${primary}cc 0%, ${secondary}66 100%)`}}
        >
          <h3 className="text-white fw-bold px-9 mt-7 mb-6">
            Notifications <span className="fs-6 opacity-75 ps-3">{isAuthorizedSAV && count}</span>
          </h3>

          {NavTabs}
        </div>

        <div className="tab-content">
          <div className="tab-content">
            <SavTabPane items={ticket_message?.data || []} scrollRef={savScrollRef} />
            <NotificationTabPane items={notifications?.data || []} scrollRef={scrollRef} />
            {
              loading === 'pending' ? (
                <div className="d-flex justify-content-center align-items-center" data-kt-indicator="on">
                  <span className="indicator-progress p-2">
                    <span className="spinner-border text-info spinner-border-sm align-middle" />
                  </span>
                </div>
              ) : null
            }
          </div>
        </div>
      </div>
    )
  )
}

export {HeaderNotificationsMenu}
